module.exports = __webpack_public_path__ + "img/send.f0e4142d.svg";